"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var didi = _interopRequireWildcard(require("@/api/didi/didi"));
var _markerMove = _interopRequireDefault(require("../order/markerMove.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'didiOrderDetail',
  components: {
    markerMove: _markerMove.default
  },
  props: {
    orderNo: {
      type: String,
      default: 0
    }
  },
  data: function data() {
    return {
      direction: 'rtl',
      dialogVisible: false,
      orderDatalist: {},
      loading: false,
      result: [],
      resultInfo: {},
      didiOrderDetailData: {},
      didiOrderFeeData: {},
      dialogFormVisible: false,
      dialogRoadsVisible: false,
      lineArr: [[116.478935, 39.997761], [116.478939, 39.997825], [116.478912, 39.998549], [116.478912, 39.998549], [116.478998, 39.998555], [116.478998, 39.998555], [116.479282, 39.99856], [116.479658, 39.998528], [116.480151, 39.998453], [116.480784, 39.998302], [116.480784, 39.998302], [116.481149, 39.998184], [116.481573, 39.997997], [116.481863, 39.997846], [116.482072, 39.997718], [116.482362, 39.997718], [116.483633, 39.998935], [116.48367, 39.998968], [116.484648, 39.999861]]
    };
  },
  watch: {},
  mounted: function mounted() {},
  methods: {
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    handleDrivingRoadsDetail: function handleDrivingRoadsDetail() {
      this.lineArr = this.didiOrderDetailData.drivingRoads;
      this.$refs.markerRoads.dialogRoadsVisible = true;
      console.log(this.lineArr);
      this.$refs.markerRoads.initMap(this.lineArr);
    },
    handleDriverInfoDetail: function handleDriverInfoDetail() {
      this.dialogFormVisible = true;
    },
    queryOrderBill: function queryOrderBill(data) {
      var _this = this;
      didi.queryOrderBill({
        platformOrderNo: data.platformOrderNo,
        merchantId: data.merchantId,
        phone: data.userRechargeInfo.rechargeAccount
      }).then(function (res) {
        _this.didiOrderFeeData = res;
      }).catch(function () {
        _this.didiOrderFeeData = {};
      });
    },
    // 获取渠道订单明细
    getOrderInvoiceList: function getOrderInvoiceList(data) {
      var _this2 = this;
      this.loading = true;
      didi.queryOrderDetail({
        platformOrderNo: data.platformOrderNo,
        merchantId: data.merchantId,
        phone: data.userRechargeInfo.rechargeAccount
      }).then(function (res) {
        _this2.loading = false;
        _this2.didiOrderDetailData = res;
      }).catch(function () {
        _this2.didiOrderDetailData = {};
        _this2.loading = false;
      });
    },
    getDetail: function getDetail(data) {
      this.orderDatalist = data;
    }
  }
};